<template>
  <div v-if="mostrar" class="overlay-expiracion">
    <div class="contenido-overlay">
      <h2>{{ titulo }}</h2>
      <p>{{ mensaje }}</p>

      <div class="contenedorBotones" v-if="modo === 'expiracion'">
        <router-link :to="{ path: '/suscripciones' }">
          <button class="boton-suscripcion">Ver precios</button>
        </router-link>
        <button class="boton-suscripcion gris" @click="cerrarSesion()">Cerrar Sesión</button>
      </div>

      <div class="contenedorBotones" v-else-if="modo === 'noauth'">
        <button class="boton-suscripcion" @click="volver()">Volver</button>
        <button class="boton-suscripcion gris" @click="cerrarSesion()">Cerrar Sesión</button>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import Swal from "sweetalert2";

export default {
  name: 'OverlayExpiracion',
  data() {
    return {
      mostrar: false,
      modo: null,      
      requerido: null, 
    }
  },
  computed: {
    titulo() {
      if (this.modo === 'noauth') return 'No estás autorizado';
      return 'Tu versión de prueba ha finalizado';
    },
   mensaje() {
  if (this.modo === 'noauth') {
    return 'Necesitás permisos extras para acceder al Panel de Administración';
  }
  return 'Para seguir usando Posmart, por favor revisá nuestros planes.';
}
  },
  methods: {
    // --- Lógica existente: expiración por cookie + meta ---
    estaExpirado() {
      const raw = Cookies.get('AccesoExpirado');
      return raw === 'true' || raw === '1' || raw === true;
    },

    // --- Nuevo: gatillo "no autorizado" por query param ---
    esNoAutorizado(route) {
      const q = route?.query || {};
      // noAuth=1 activa el modo; required=superadmin (opcional) para mostrar el rol pedido
      if (q.noAuth === '1' || q.noAuth === 1 || q.noAuth === true) {
        this.requerido = (q.required || '').toString();
        return true;
      }
      return false;
    },

    updateOverlay(route = this.$route) {
      const necesitaSuscripcion = route?.meta?.requiereSuscripcion;
      const expirado = this.estaExpirado();
      const noAuth = this.esNoAutorizado(route);

      // Prioridad: 1) expiración  2) no autorizado
      if (necesitaSuscripcion && expirado) {
        this.modo = 'expiracion';
        this.abrir();
      } else if (noAuth) {
        this.modo = 'noauth';
        this.abrir();
      } else {
        this.cerrar();
      }
    },

    abrir() {
      if (!this.mostrar) {
        this.mostrar = true;
        document.body.style.overflow = 'hidden';
      }
    },
    cerrar() {
      if (this.mostrar) {
        this.mostrar = false;
        document.body.style.overflow = '';
        this.modo = null;
        this.requerido = null;
      }
    },

    async cerrarSesion() {
      const result = await Swal.fire({
        title: "¿Estás seguro?",
        text: "Estás a punto de cerrar la sesión, ¿deseas continuar?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, continuar",
        cancelButtonText: "No, cancelar",
        reverseButtons: true,
      });
      if (!result.isConfirmed) return;

      // Eliminar cookies
      Cookies.remove("token");
      Cookies.remove("nombre");
      Cookies.remove("apellido");
      Cookies.remove("empresa");
      Cookies.remove("FechaExpiracion");
      Cookies.remove("AccesoExpirado");

      this.cerrar();

      await Swal.fire({
        icon: "success",
        title: "Sesión cerrada",
        text: "Has cerrado sesión correctamente.",
        timer: 1500,
        showConfirmButton: false,
      });

      this.$router.push("/ingresar");
    },

    volver() {
      // Limpia el query param para que no reabra el overlay
      const { query, path } = this.$route;
      if (query.noAuth) {
        const cleaned = { ...query };
        delete cleaned.noAuth;
        delete cleaned.required;
        this.$router.replace({ path, query: cleaned });
      }

      if (window.history.length > 1) {
        this.$router.back();
      } else {
        this.$router.push("/");
      }
      this.cerrar();
    },
  },

  mounted() {
    this.updateOverlay();
  },
  watch: {
    $route(to) {
      this.updateOverlay(to);
    }
  },
  unmounted() {
    document.body.style.overflow = '';
  }
}
</script>

<style scoped>
.overlay-expiracion {
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  z-index: 3;
  display: flex;
  justify-content: center;
  align-items: center;
}

.contenido-overlay {
  background: white;
  border-radius: 1vw;
  padding: 2vw;
  text-align: center;
  max-width: 90%;
}

.boton-suscripcion {
  background: linear-gradient(90deg, #132f6f 0%, #78b12a 100%);
  color: white;
  font-weight: bold;
  padding: 1vw 2vw;
  border-radius: 0.5vw;
  border: none;
  margin-top: 1vw;
  cursor: pointer;
}

.gris {
  background: linear-gradient(90deg, #132f6f 0%, #646661 100%);
  font-weight: normal;
}

.contenedorBotones {
  display: flex;
  justify-content: space-around;
  gap: 1rem;
  flex-wrap: wrap;
}
</style>